module.exports = __webpack_public_path__ + "img/truckspics_s.025f8c9e.jpg";